import {
	dispatchAcknowledgedEvent,
	openResourceSection,
} from '../../core/resourceEvents';
import {
	AP_FILTER_EVENT,
	AP_FOCUS_EVENT,
	AP_BULK_SECTION_EVENT,
	AP_SECTION_EVENT,
} from './events';

const SECTIONS = new Set(['home.access_points', 'site.access_points']);

/**
 * Open an Access Point inventory section.
 * @param {string} sectionId semantic section identifier
 * @return {Promise<void>} section acknowledgement
 */
export function openAccessPointSection(sectionId) {
	return openResourceSection(AP_SECTION_EVENT, sectionId, SECTIONS);
}

/**
 * Apply an Access Point inventory query.
 * @param {string} query Access Point query
 * @param {string|null} status connection status to narrow to
 * @return {Promise<void>} filter acknowledgement
 */
export function applyAccessPointFilter(query, status = null) {
	const text = typeof query === 'string' ? query.trim() : '';
	const state = typeof status === 'string' ? status.trim() : '';
	// A status narrows the list on its own, so a request that only asks for
	// online Access Points carries no search text.
	if (!text && !state) {
		return Promise.reject(new Error('invalid_access_point_filter'));
	}
	return dispatchAcknowledgedEvent(AP_FILTER_EVENT, {
		query: text,
		status: state || null,
		resource: 'ap',
	});
}

/**
 * Focus a resolved Access Point row.
 * @param {string} entityId opaque Access Point identifier
 * @return {Promise<void>} focus acknowledgement
 */
export function focusAccessPoint(entityId) {
	if (typeof entityId !== 'string' || !entityId) {
		return Promise.reject(new Error('invalid_access_point_entity'));
	}
	return dispatchAcknowledgedEvent(AP_FOCUS_EVENT, {
		entityId,
		resource: 'ap',
	});
}

const BULK_SECTIONS = new Set([
	'maintenance.bulk_add_access_points',
	'maintenance.bulk_ap_actions',
]);

/**
 * Open one of the bulk screens on the Maintenance tab.
 *
 * Bulk work lives there rather than beside the inventory it acts on, and
 * each screen is chosen inside that page rather than being a route of its
 * own - the same arrangement the Switch bulk screens already use.
 *
 * @param {string} sectionId semantic section identifier
 * @return {Promise<void>} completion acknowledgement
 */
export function openAccessPointBulkSection(sectionId) {
	return openResourceSection(
		AP_BULK_SECTION_EVENT,
		sectionId,
		BULK_SECTIONS,
	);
}
